import React from 'react'

import { ThemeProvider, createTheme } from '@mui/material/styles'

import Routes from './Router'

function App() {
  const theme = createTheme({
    typography: {
      fontFamily: ['Cherry Bomb One', 'ZCOOL KuaiLe', 'sans-serif'].join(',')
    }
  })

  return (
    <ThemeProvider theme={theme}>
      <Routes />
    </ThemeProvider>
  )
}

export default App
